import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import SEOHead from '../components/SEOHead';

const PrivacyPolicy = () => {
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://donorshouse.com';

  const breadcrumbs = [
    { name: 'Home', url: siteUrl },
    { name: 'Privacy Policy', url: `${siteUrl}/privacy` }
  ];

  return (
    <>
      <SEOHead
        title="Privacy Policy | DonorsHouse - Your Data Protection Commitment"
        description="Read DonorsHouse's Privacy Policy to understand how we collect, use, and protect your personal information. Learn about your rights and our commitment to data security."
        keywords="privacy policy, data protection, privacy rights, personal information, data security, GDPR, user privacy"
        breadcrumbs={breadcrumbs}
      />
      <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <Card className="shadow-md mb-6">
          <CardHeader>
            <CardTitle className="text-gray-900">1. Information We Collect</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-700 space-y-3">
            <p>We collect information that you provide directly to us, including:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Personal identification information (name, email address, phone number, address)</li>
              <li>Medical information (blood type, organ donation pledges)</li>
              <li>Emergency contact information</li>
              <li>Family member information (when voluntarily provided)</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-md mb-6">
          <CardHeader>
            <CardTitle className="text-gray-900">2. How We Use Your Information</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-700 space-y-3">
            <p>We use the information we collect to:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Connect donors with recipients in need</li>
              <li>Maintain and improve our services</li>
              <li>Send you updates about blood requests in your area (if opted in)</li>
              <li>Verify donation center information</li>
              <li>Comply with legal obligations</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-md mb-6">
          <CardHeader>
            <CardTitle className="text-gray-900">3. Information Sharing</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-700 space-y-3">
            <p>We do not sell your personal information. We may share your information only:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>With your explicit consent</li>
              <li>With verified medical facilities when you respond to a blood request</li>
              <li>As required by law or legal process</li>
              <li>To protect the rights, property, or safety of DonorsHouse, our users, or others</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-md mb-6">
          <CardHeader>
            <CardTitle className="text-gray-900">4. Data Security</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-700 space-y-3">
            <p>
              We implement appropriate technical and organizational measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission 
              is completely secure, and we cannot guarantee absolute security.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-md mb-6">
          <CardHeader>
            <CardTitle className="text-gray-900">5. Your Rights</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-700 space-y-3">
            <p>You have the right to:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt-out of marketing communications</li>
              <li>Withdraw consent where applicable</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="shadow-md mb-6">
          <CardHeader>
            <CardTitle className="text-gray-900">6. Children's Privacy</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-700">
            <p>
              Our services are not directed to individuals under 18. We do not knowingly collect personal 
              information from children. If you believe we have collected information from a child, please contact us.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-md mb-6">
          <CardHeader>
            <CardTitle className="text-gray-900">7. Changes to This Policy</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-700">
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
              the new policy on this page and updating the "Last Updated" date.
            </p>
          </CardContent>
        </Card>

        <Card className="shadow-md">
          <CardHeader>
            <CardTitle className="text-gray-900">8. Contact Us</CardTitle>
          </CardHeader>
          <CardContent className="text-gray-700">
            <p>If you have questions about this Privacy Policy, please contact us at:</p>
            <p className="mt-2 font-semibold">https://newabilities.org/contact</p>
          </CardContent>
        </Card>

        <p className="text-center text-gray-600 mt-8">Last Updated: January 2025</p>
      </div>
    </div>
    </>
  );
};

export default PrivacyPolicy;
